import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Input from '../../../components/elements/form/input';
import Teaxtarea from '../../../components/elements/form/textarea';
import SelectBox from '../../../components/elements/form/selectBox';
import { DropdownOptionType, Option } from '../../../_config/types';
import Datepicker from '../../../components/elements/form/datepicker';
import Button from '../../../components/elements/button';
import mapImg from '../../../images/map-left.jpg';
import qrImg from '../../../images/facility-qr.jpg';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import toast from 'react-hot-toast';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';
import { useAppLoader } from '../../../_common/pageLoader/appLoaderHook';
import Icon from '../../../components/icons';
import FileUpload from '../../../components/elements/form/fileUplaod';
import { on } from 'events';

interface Props {
    _ref: React.RefObject<HTMLDialogElement>
    facilityId: string | number
    onCreate?: () => void
    onCancel?: () => void
    subFacility?: any
}



const CreateSubFacilitiesModal: React.FC<Props> = ({ _ref, facilityId, onCreate = () => { }, onCancel = () => { }, subFacility }) => {

    const facilityApi: any = useFacilitiesApi();
    const [subfacilitytype, setsubfacilitytype] = useState<any>([]);
    const { showLoader, hideLoader } = useAppLoader()
    const [subfacilityimg, setSubfacityImg] = useState<any>(null);
    const { control, register, getValues, reset, handleSubmit, formState: { errors } } = useForm<any>();

    const colse = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        resetForm();
        _ref?.current?.close()
        onCancel()
    }


    const onSubmit = (data: any) => {
        //  console.log(data);
        let payload: any = {
            "subFacilityTypeID": data.subFacilityTypeID.value,
            "subFacilityName": data.subFacilityName,
            "area": data.area,
            "no": data.noOfRanches,
            "facilityID": facilityId
        }

        if (subFacility) {
            payload = {
                ...payload,
                "subFacilityID": subFacility.subFacilityID
            }
        }

        showLoader();
        facilityApi.saveSubFacility(payload, (resp: any) => {
            if (typeof data?.fileupload == 'object') {
                const formData = new FormData();
                formData.append('inputFile', data.fileupload);
                formData.append('subFacilityID', resp?.returnID);
                facilityApi.SaveSubFacilityImage(formData, (resp: any) => {
                    toast.success("Sub Facility Added Successfully")
                    reset();
                    hideLoader();
                    _ref?.current?.close()
                }, (error: any) => {
                    hideLoader();
                    toast.error(error);
                });
            } else {
                hideLoader();
                toast.success("Sub Facility Added Successfully")
                reset();
                _ref?.current?.close()
                return;
            }
        }, (error: any) => {
            hideLoader();
            toast.error(error);
        });



    }
    const GetSubFacilityTypeList = () => {
        const payload = {
            pageNo: 1,
            pageSize: 10
        };
        facilityApi.getSubFacilityTypeList(payload, (resp: any) => {
            // console.log("Subfacility type",resp)
            let servicetech: any = [];

            resp.subFacilityTypeList.map((servicelist: any) => {
                servicetech.push({
                    label: servicelist.name,
                    value: servicelist.subFacilityTypeID,
                })

                setsubfacilitytype(servicetech);

            });


        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });
    };

    const resetForm = () => {
        reset({
            subFacilityTypeID: null,
            area: null,
            noOfRanches: null,
            fileupload: null
        });
    }

    useEffect(() => {
        if (subFacility) {
            console.log('edit sub facility with ---- ',subFacility);
            reset({
                subFacilityTypeID: subfacilitytype.find((item: any) => item.value == subFacility.subFacilityTypeID),
                area: subFacility.area,
                noOfRanches: subFacility.no,
                fileupload: subFacility.fullFilePath
            })
        } else {
            resetForm();
        }
    }, [subFacility])

    useEffect(() => {
        GetSubFacilityTypeList();
    }, [])

    return (
        <dialog ref={_ref} className="modal">
            <div className="modal-box max-w-[90%] w-[50rem] p-4">
                <form onSubmit={handleSubmit(onSubmit)}>

                    <div className='flex items-center justify-between border-b border-[#8D6E63] pb-2 mb-2'>
                        <p className='text-[1.063rem] text-[#755B51] font-semibold'>{subFacility ? 'Edit' : 'Add New'} Sub facility</p>
                        <button onClick={colse} className='bg-primary text-white p-1 rounded-md'>
                            <Icon name='close' size={1.25} />
                        </button>
                    </div>

                    <div className='py-3'>

                        <Controller
                            name='subFacilityTypeID'
                            control={control}
                            rules={{ required: 'Sub facility type is required' }}
                            render={({ field: { value, onChange } }) => (
                                <SelectBox
                                    label='Select Sub  Facility type'
                                    required
                                    value={value}
                                    onChange={onChange}
                                    placeholder='Choose Processing Facility'
                                    options={subfacilitytype}
                                    error={errors?.subFacilityTypeID?.message as any}
                                />
                            )}
                        />

                        <div className='grid grid-cols-9 gap-2'>
                            <div className='col-span-4'>
                                <Controller
                                    name='area'
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <Input
                                            label='Area'
                                            type='text'
                                            value={value}
                                            onChange={onChange}

                                            placeholder='Enter Area in sqft'
                                            error={errors.area?.message as any}
                                        />
                                    )}
                                />
                            </div>
                            <div className='flex items-center justify-center mt-6'>sqft</div>
                            <div className='col-span-4'>
                                <Controller
                                    name='noOfRanches'
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <Input
                                            label='No of Ranches'
                                            type='text'
                                            value={value}
                                            onChange={onChange}

                                            placeholder='No of Ranches'
                                            error={errors.noOfRanches?.message as any}
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <Controller
                            name='fileupload'
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <FileUpload
                                    label='Select Processing Facility'
                                    value={value}
                                    accept=".jpg, .jpeg, .png"
                                    onChange={(e: any) => {
                                        onChange(e.target.files[0])
                                    }}
                                    placeholder='Choose Processing Facility'
                                    error={errors?.fileupload?.message as any}
                                />
                            )}
                        />

                    </div>


                    <div className='flex justify-end gap-2 border-t border-[#8D6E63] pt-2'>
                        <Button type="button" theme='secondary' onClick={colse}>Cancel</Button>
                        <Button type="submit" >Save</Button>
                    </div>

                </form>
            </div>
            <form method="dialog" className="modal-backdrop" onClick={colse}></form>
        </dialog>
    );
};

export default CreateSubFacilitiesModal;